import React, { useEffect, useState } from 'react'
import { Tabs } from 'antd'
import type { TabsProps } from 'antd'
import SettingPage from './setting/SettingPage'
import { useParams } from 'react-router-dom'
import useGlobalConfigStore from '@/stores/globalConfig'
import useOneStationStore from '@/stores/oneStation'
import { getDeviceFuns } from '@/api/powerStation'
import MqttServer from '@/utils/mqttUtil'
import inverterDeviceSettings from './setting/inverter'
import useMessage from '@/hooks/useMessage'

const Setting: React.FC = () => {
  const { deviceId } = useParams()
  const [tabData, setTabData] = useState<TabsProps['items']>([])
  const initFinished = useGlobalConfigStore(state => state.initFinished)
  const device = useOneStationStore(state => state.device)
  const mqtt_serve = useOneStationStore(state => state.mqtt_serve)
  const access_device = useOneStationStore(state => state.access_device)
  const { message } = useMessage()
  let id: number = 0

  const tempid = 21
  let uuid = '',
    modid = 0,
    mqtt: MqttServer | undefined = undefined

  const getGroup = async () => {
    let res: any
    try {
      res = await getDeviceFuns({
        gateway_uuid: uuid,
        tempid,
        modid,
      })
      // console.log(res)
      if (res.code === 1001) {
        const tempTabData = res.data.groups.map((item: { group_id: number; group_name: string }) => ({
          key: item.group_id,
          label: item.group_name,
          children: (
            <SettingPage
              mqtt={mqtt as MqttServer}
              uuid={uuid}
              id={id}
              groupName={item.group_name}
              groupData={inverterDeviceSettings.find(gi => gi.group_name === item.group_name)?.groupData || []}
            />
          ),
        }))
        // console.log(tempTabData)
        setTabData(tempTabData)
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getDataAllStep = async () => {
    const target = device.find(item => item.device_id === id)
    if (target) {
      uuid = target.iot_gateway_uuid
      mqtt = mqtt_serve[target.mqtt_server_id]
      const targetAccessDevice = access_device.find(item => item.device_id === id)
      if (targetAccessDevice) {
        modid = targetAccessDevice.mod_id
        await getGroup()
      }
    }
  }

  useEffect(() => {
    if (initFinished) {
      id = device.find(item => item.id === Number(deviceId))?.device_id || 0
      if (id !== 0) {
        getDataAllStep()
      } else {
        message.error('Get Device ID Error')
      }
    }
  }, [initFinished])

  return (
    <div id='setting'>
      <Tabs items={tabData} style={{ height: '100%' }} destroyInactiveTabPane={true} />
    </div>
  )
}

export default Setting
